export const MARKETING_TRIGGER_SYNC = 0;
export const MARKETING_TRIGGER_ASYNC = 1;

export const MARKETING_TRIGGER_EVENT_TYPE = 0;
export const MARKETING_TRIGGER_SCHEDULE_TYPE = 1;

export const MarketingTriggerExecItems = {
    [MARKETING_TRIGGER_SYNC]: 'Синхронно',
    [MARKETING_TRIGGER_ASYNC]: 'Acинхронно',
} as const

export const MarketingTriggerTypeItems = {
    [MARKETING_TRIGGER_EVENT_TYPE]: 'По событию',
    [MARKETING_TRIGGER_SCHEDULE_TYPE]: 'По расписанию',
} as const

export const USER_VALUE = 1
export const EVENT_VALUE = 2
